// extracted by mini-css-extract-plugin
export default {"videoTitle":"video_videoTitle__9uaV4","videoWrapper":"video_videoWrapper__21WSX","videoContainer":"video_videoContainer__zQ3I+"};